<template>
  <div class="tab-text">
    <div class="vx-row mb-4">
      <div class="vx-col sm: w-full md:w-1/2 mt-4 set_limit">
        <label class="limit_label">{{ $t("labels.show") }}</label>
        <v-select v-model="limit" :options="limitarr" :reduce="(limitarr) => limitarr.value" :clearable="false"
          label="text" class="px-1" />
        <label class="limit_label">{{ $t("labels.consultants") }}</label>
      </div>
      <div class="vx-col sm: w-full md:w-1/2">
        <div class="mt-4 float-right flex">
          <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-filter"
            @click="showfilter = !showfilter" class="mr-2 btn-color">{{ $t("labels.filter") }}</vs-button>
          <vs-button color="dark" type="filled" icon-pack="feather" icon="icon-upload" class="ml-4 btn-color"
            @click.prevent="exportCsv()">{{ $t("labels.export") }}</vs-button>
        </div>
      </div>
    </div>
    <vx-card class="filter-card filter_card" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input icon-pack="feather" icon="icon-search" v-model="search" class="w-full" />
        </div>
        <div class="vx-col md:w-1/3">
          <label class="pl-1">{{ $t("labels.block_unblock") }}</label>
          <v-select v-model="block" :options="filterBlock" :reduce="(filterBlock) => filterBlock.value" label="text"
            class="filter-dropdown" />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-filter" :title="$t('labels.filter')"
            @click.prevent="filter()" :disabled="!this.search && !this.block"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn">{{ $t("labels.filter") }}</vs-button>
          <vs-button color="maroon" type="filled" icon-pack="feather" icon="icon-x" :title="$t('labels.filter')"
            @click="clearFilter()" :disabled="!this.search && !this.block"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn">{{ $t("labels.clear") }}</vs-button>
        </div>
      </div>
    </vx-card>
    <vs-table :data="consultants" class="permission">
      <template slot="thead">
        <vs-th class="col-md-4">{{ $t("labels.name") }}</vs-th>
        <vs-th class="col-md-3">{{ $t("labels.email") }}</vs-th>
        <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
          v-bind:class="[tr.is_blocked == 1 ? 'user-table' : '']">
          <vs-td :data="tr.username">
            <router-link class="view-link" :to="{ name: 'ViewUser', params: { id: tr.id } }"
              v-if="checkPermission('user', 'view')">{{ tr.name }}</router-link>
          </vs-td>
          <vs-td :data="tr.email">{{ tr.email }}</vs-td>
          <vs-td width="264">
            <div class="flex">
              <router-link class="view-link" :to="{ name: 'ViewUser', params: { id: tr.id } }"
                v-if="checkPermission('user', 'view')">
                <vs-button type="flat" :title="$t('labels.view')" size="large" icon-pack="feather" icon="icon-eye"
                  class="btn-icon" color="dark"></vs-button>
              </router-link>
              <router-link class="view-link" :to="{ name: 'EditUser', params: { id: tr.id } }"
                v-if="checkPermission('user', 'modify')">
                <vs-button type="flat" :title="$t('labels.edit')" size="large" icon-pack="feather" icon="icon-edit"
                  color="success" class="btn-icon"></vs-button>
              </router-link>

              <vs-button @click="deleteConfirm(indextr)" type="flat" :title="$t('labels.delete')" size="large"
                icon-pack="feather" icon="icon-trash-2" color="danger" class="btn-icon"
                v-if="checkPermission('user', 'delete')">
              </vs-button>
              <vs-button @click="blockConfirm(indextr)" type="flat" :title="!tr.is_blocked ? $t('labels.block') : $t('labels.unblock')
                " size="large" icon-pack="feather" :icon="tr.is_blocked ? 'icon-unlock' : 'icon-lock'"
                :color="tr.is_blocked ? 'primary' : 'warning'" class="btn-icon">
              </vs-button>
              <vs-button type="flat" :title="$t('labels.reset_pass_button')" size="small" class="key-icon btn-icon"
                color="success" @click="resetPassConfirm(indextr)">
                <key-icon size="2x" class="custom-class" color="danger"></key-icon>
              </vs-button>
              <vs-button @click="downloadDocument(tr)" type="flat" :title="$t('labels.download_document')" size="large"
                icon-pack="feather" icon="icon-download" color="danger" class="btn-icon"
                v-if="checkPermission('user', 'delete')">
              </vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="float-right mt-6">
      <vs-pagination color="dark" :total="$store.state.userData.consultantCount" v-model="currentx" class="mb-1">
      </vs-pagination>
    </div>
  </div>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";
import { EventBus } from "@/mixins/mixin.js";

export default {
  data() {
    return {
      currentx: this.$store.state.userData.consultantCurrent,
      // limit: parseInt(process.env.VUE_APP_PER_PAGE),
      limit: this.$store.state.limit,
      showfilter: false,
      search: this.$store.state.userData.consultantSearch,
      block: this.$store.state.userData.consultantBlock,
      filterBlock: [
        { text: this.$t("labels.block"), value: true },
        { text: this.$t("labels.unblock"), value: false },
      ],
    };
  },
  components: {
    KeyIcon,
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    if (
      this.$store.state.userData.consultantSearch ||
      this.$store.state.userData.consultantBlock
    ) {
      this.showfilter = true;
    }
    this.$store.commit("UPDATE_TAB", 2);
  },
  watch: {
    currentx(val) {
      this.$store.commit("updateConsultantCurrent", val, {
        module: "userData",
      });
      EventBus.$emit("pageChanged", "CN");
    },
    limit(val) {
      localStorage.setItem("limit", val);
      this.$store.commit("updateConsultantLimit", val, { module: "userData" });
      this.currentx = 1;
      EventBus.$emit("limitChanged", "CN");
    },
  },
  computed: {
    consultants() {
      return this.$store.state.userData.consultants;
    },
  },
  methods: {
    deleteConfirm(indextr) {
      EventBus.$emit("deleteConfirm", indextr);
    },
    blockConfirm(indextr) {
      EventBus.$emit("blockConfirm", indextr);
    },
    resetPassConfirm(indextr) {
      EventBus.$emit("resetPassConfirm", indextr);
    },
    exportCsv() {
      EventBus.$emit("export", "CN");
    },
    filter() {
      this.$store.commit("updateConsultantSearch", this.search, {
        module: "userData",
      });
      this.$store.commit("updateConsultantBlock", this.block, {
        module: "userData",
      });
      EventBus.$emit("filter", "CN");
    },
    clearFilter() {
      this.search = null;
      this.block = null;
      this.$store.commit("updateConsultantSearch", null, {
        module: "userData",
      });
      this.$store.commit("updateConsultantBlock", null, {
        module: "userData",
      });
      EventBus.$emit("filter", "CN");
    },
    async downloadDocument(trData) {
      this.$vs.loading();
      let input = {};
      if (this.$store.state.userInfo.type === "A") {
        input = Object.assign(
          {
            user_id: trData.id,
          },
          input
        );
      }
      this.axios
        .post("/consultants/report", input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;
          // var currentDate = new Date();
          var formatted_date = new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "_");
          let pdfName = trData.name + "_" + formatted_date;
          this.exportPdfFile(data, pdfName);
          this.export = 0;
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
  },
};
</script>
<style scoped>
.btn-icon {
  width: 30px !important;
  height: 30px !important;
  padding: 16px !important;
}
</style>
